const HorizontalLine: React.FC = () => {
    return <div style={{
            height: '2.5px', 
            backgroundColor: 'var(--border-color-m)',
            marginTop: 8,
            width: '100%'}}></div>
}

export default HorizontalLine;